import React from "react";
import { MapContainer, ZoomControl } from "react-leaflet";

import { Cursor } from "../../types/all";
import { MapCursor } from "./MapCursor";
import { MapEvents } from "./MapEvents";
import { MapLayers } from "./MapLayers";

export const DrawingMapCanvas = ({
  center,
  children,
  className = "h-full w-full",
  cursor = "grab",
  draggable = true,
  maxNativeZoom = 19,
  maxZoom = 40,
  minZoom = 3,
  onMapClick,
  onMapDoubleClick,
  onMapMouseMove,
  onMapMouseOut,
  zoom = 18,
  zoomControl = true,
  zoomDelta = 0.5,
  zoomSnap = 0.5,
}: {
  center: [number, number];
  children: React.ReactNode;
  className?: string;
  cursor?: Cursor;
  draggable?: boolean;
  maxNativeZoom?: number;
  maxZoom?: number;
  minZoom?: number;
  onMapClick?: (event: any) => void;
  onMapDoubleClick?: (event: any) => void;
  onMapMouseMove?: (event: any) => void;
  onMapMouseOut?: (event: any) => void;
  zoom?: number;
  zoomControl?: boolean;
  zoomDelta?: number;
  zoomSnap?: number;
}) => {
  return (
    <MapContainer
      center={center}
      className={className}
      doubleClickZoom={false}
      dragging={draggable}
      maxZoom={maxZoom}
      minZoom={minZoom}
      zoom={zoom}
      zoomControl={false}
      zoomDelta={zoomDelta}
      zoomSnap={zoomSnap}
    >
      <MapLayers layerProps={{ maxNativeZoom, maxZoom }} layers={["Satellite", "Standard"]} />
      <MapCursor cursor={cursor} />
      <MapEvents
        onMapClick={onMapClick}
        onMapDoubleClick={onMapDoubleClick}
        onMapMouseMove={onMapMouseMove}
        onMapMouseOut={onMapMouseOut}
      />
      {zoomControl && <ZoomControl position="bottomright" />}
      {children}
    </MapContainer>
  );
};
